export * from './operation';
export * from './operation-type';



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/datastore/operations/index.js